import { createStyles } from "@mantine/core";

const useStyles = createStyles((theme) => {
  const { colors } = theme.other;

  return {
    container: {
      width: '100%',
      height: '100%',
      overflowY: 'auto',
      display: 'flex',
      flexDirection: 'column',
      backdropFilter: 'blur(34px)',
      overflow: 'hidden',
      backgroundColor: colors.bg.default,
    },
    contentContainer: {
      padding: '1.25rem',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      paddingTop: '0',
      overflowX: "scroll",
      "::-webkit-scrollbar": {
        width: "4px",
        background: "transparent",
      },
    },
    footerContainer: {
      display: 'flex',
      justifyContent: "space-between",
      width: '100%',
      position: 'absolute',
      bottom: 0,
      padding: ".5rem 1rem",
      background: colors.base.white,
    },
  }
});

export default useStyles;
